import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import {
  Board,
  getQualificationBoard,
} from '@/services/workflow/qualification';

export const QUALIFICATION_BOARD_QUERY_KEY = 'qualification-board';

export const useQualificationBoard = (
  client: string | undefined,
  region: string | undefined,
  waveId?: string,
  options?: Partial<UseQueryOptions<Board, Error>>,
) =>
  useQuery<Board, Error>({
    queryKey: [QUALIFICATION_BOARD_QUERY_KEY, client, region, waveId],
    queryFn: async ({ signal }) => {
      if (!client || !region) throw new Error('No client or region');
      return getQualificationBoard(client, region, waveId, signal);
    },
    enabled: !!client && !!region,
    // An operator watching a wave move wants the board to reflect a
    // decision someone else just took.
    staleTime: 0,
    refetchOnWindowFocus: true,
    ...options,
  });
